module.exports = __webpack_public_path__ + "static/media/notebook06.f829b10c.jpg";